import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyKeyboardNav(enabled) {
  toggleHtmlClass(CLASSES.keyboardNav, enabled);
}
